/** @jsxRuntime classic */
/** @jsx jsxCustomEvent */
import jsxCustomEvent from '@micro-zoe/micro-app/polyfill/jsx-custom-event';
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import React from 'react';
import classnames from 'classnames';
import style from './style.less';

@BindAll()
export class MicroApp extends React.Component<{
  name: string;
  url: string;
  [key: string]: any;
}> {
  get url() {
    return this.props.url;
  }
  state = {
    loading: false,
  };
  get loading() {
    return this.state.loading;
  }
  set loading(loading) {
    this.setState({ loading });
  }
  componentDidMount() {
    React.$Mamba.Log.success(` Micro `, this);
  }
  onDataChange(event) {
    console.log('LENG ~ MicroApp', event);
    lodash.invoke(this.props, 'onDataChange', event);
  }
  onCreated(event) {
    console.log('micro-app元素被创建', event);
    this.loading = true;
    lodash.invoke(this.props, 'onCreated', event);
  }
  onBeforemount(event) {
    console.log('即将被渲染', event);
    lodash.invoke(this.props, 'onBeforemount', event);
  }
  onMounted(event) {
    console.log('已经渲染完成', event);
    this.loading = false;
    lodash.invoke(this.props, 'onMounted', event);
  }
  onUnmount(event) {
    console.log('已经卸载', event);
    lodash.invoke(this.props, 'onUnmount', event);
  }
  onError(event) {
    console.log('渲染出错', event);
    this.loading = false;
    lodash.invoke(this.props, 'onError', event);
  }
  render() {
    if (this.url) {
      return (
        <React.Fragment>
          {this.loading && <React.Antd.ProSkeleton type="list" />}
          <micro-app
            class={classnames(style.micro)}
            url={this.url} // url(必传)：应用地址，会被自动补全为http://localhost:3000/index.html
            onDataChange={this.onDataChange}
            onCreated={this.onCreated}
            onBeforemount={this.onBeforemount}
            onMounted={this.onMounted}
            onUnmount={this.onUnmount}
            onError={this.onError}
            {...lodash.omit(this.props, [
              'url',
              'onDataChange',
              'onCreated',
              'onBeforemount',
              'onMounted',
              'onUnmount',
              'onError',
            ])}
          />
        </React.Fragment>
      );
    }
    return (
      <React.Antd.Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <React.Antd.Button
            type="primary"
            onClick={() => this.$router.replace(this.$Pages.Home)}
          >
            Back Home
          </React.Antd.Button>
        }
      />
    );
  }
}
